<template>
  <el-dialog :visible.sync="dialogVisible" title="工序统计详情" top="5vh" width="70%" @close="handleClose">
    <div style='display: flex; align-items: center;'>
      样品编号:
      <el-input v-model="smpl_no" placeholder="请输入样品编号" size='small' style='width: 300px; margin-right: 10px;'/>
      <el-button size="small" type="primary" @click="getDetailData">查询</el-button>
    </div>
    
    <el-table v-loading="loading" :data="tableData" border style="width: 100%" @row-dblclick="handleRowDblclick">
      <el-table-column align="center" label="委托单号" prop="requ_no" />
      <el-table-column align="center" label="样品编号" prop="smpl_no" />
      <el-table-column align="center" label="更改号" prop="smpl_suffix" />
      <el-table-column align="center" label="样品名称" prop="smpl_name" />
      <el-table-column :formatter="(row, column, cellValue) => (cellValue === 1 || cellValue === '新款' ? '新款' : cellValue === 2 || cellValue === '老款' ? '老款' : '修改款')" align="center" label="样品类型" prop="smpl_type" />
    </el-table>
    <div slot="footer" class="dialog-footer">
      合计: {{ tableData.length }}
    </div>
  </el-dialog>
</template>

<script>
import { get } from '@api/request';
import { dataStaticsAPI } from '@api/modules/stat';

export default {
  name: 'ProcessStatisticsDialog',
  props: {
    visible: Boolean,
    module: String,
    condition: String,
    stffName: String,
    startTime: [Number, String],
    endTime: [Number, String]
  },
  data() {
    return {
      dialogVisible: false,
      loading: false,
      tableData: [],
      smpl_no:''
    };
  },
  watch: {
    visible(val) {
      this.dialogVisible = val;
      if (val) {
        this.getDetailData();
      }
    },
    dialogVisible(val) {
      if (!val) {
        this.$emit('update:visible', false);
      }
    }
  },
  methods: {
    handleRowDblclick(row) {
      this.handleClose();
      this.jump(`/smpl_edit?perm_id=112&form_id=${row.smpl_id}`);
    },
    handleClose() {
      this.$emit('update:visible', false);
    },
    getDetailData() {
      this.loading = true;
      let endDate = this.endTime ? new Date(this.endTime) : null;
      if (endDate) {
        endDate.setHours(23, 59, 59, 999);
      }
      const params = {
        module: this.module,
        stff_name: this.stffName || null,
        condition: this.condition || '制作',
        start_time: this.startTime ? Math.floor(new Date(this.startTime).getTime() / 1000) : null,
        end_time: this.endTime ? Math.floor(endDate.getTime() / 1000) : null,
        smpl_no: this.smpl_no || null
      };
      get(dataStaticsAPI.getYzProcessStatistics, params)
        .then(({ data }) => {
          if (data.code === 0) {
            this.tableData = data.data.list || [];
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    }
  }
};
</script>
